<template>
  <div class="content-container">
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item>
        <el-button type="primary" icon="el-icon-plus" @click="onAdd"
          >新增广告</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-delete"
          @click="onBatchDelete"
          :disabled="multipleSelection.length === 0"
          >批量删除</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="advertisementNo" label="广告编号" width="200">
      </el-table-column>
      <el-table-column prop="remark" label="说明" width="200">
      </el-table-column>
      <el-table-column label="图片">
        <template slot-scope="scope">
          <div>
            <img
              :src="'/api/shared/getImage?ossFileKey=' + scope.row.imageUrl"
              v-if="scope.row.imageUrl"
              width="200px"
              height="100px"
              style="cursor:pointer"
              @click="showBig(scope.row.imageUrl)"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="url" label="链接"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    >
    </el-pagination>

    <el-dialog title="查看图片" :visible.sync="imageBigVisible" width="900px">
      <el-carousel trigger="click" height="640px">
        <img class="movie-img" :src="currentImageUrl" alt="" srcset="" />
      </el-carousel>
      <span slot="footer" class="dialog-footer">
        <el-button @click="imageBigVisible = false">取 消</el-button>
        <el-button type="primary" @click="imageBigVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <EditDialog
      v-if="isDialogShow"
      @closeForm="closeForm"
      @handleUpdate="onSubmit"
      :isCreate="isCreate"
      :advertisementInfo="advertisementInfo"
    />
  </div>
</template>
<script>
import EditDialog from "./components/editDialog";

export default {
  components: {
    EditDialog
  },
  data() {
    return {
      isCreate: true,
      isDialogShow: false,
      multipleSelection: [],
      advertisementInfo: null,
      currentImageUrl: "",
      imageBigVisible: false,
      tableData: [],
      page: { total: 0, currentPage: 1, pageSize: 10 }
    };
  },
  methods: {
    onSubmit() {
      let queryModel = {};
      this.$axios(this.$urlMapping["查询广告"], {
        data: queryModel
      }).then(result => {
        this.tableData = result.data;
        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },
    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSubmit();
    },
    onAdd() {
      this.advertisementInfo = null;
      this.isCreate = true;
      this.isDialogShow = true;
    },
    onBatchDelete() {
      if (this.multipleSelection.length > 0) {
        this.$confirm("是否确认删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          let ids = this.multipleSelection.map(ele => ele.id);
          this.$axios(this.$urlMapping["删除广告"], {
            data: {
              ids
            }
            // eslint-disable-next-line no-unused-vars
          }).then(result => {
            this.$notifySuccess();
            this.onSubmit();
          });
        });
      } else {
        this.$notify.info({
          title: "消息",
          message: "至少选择一条进行删除"
        });
      }
    },
    handleEdit(advertisementInfo) {
      console.log(advertisementInfo);
      this.advertisementInfo = advertisementInfo;
      this.isCreate = false;
      this.isDialogShow = true;
    },
    showBig(url) {
      console.log(url);
      if (url) {
        this.currentImageUrl = "/api/shared/getImage?ossFileKey=" + url;
        this.imageBigVisible = true;
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    closeForm() {
      this.isDialogShow = false;
    }
  },
  mounted() {
    this.onSubmit();
  }
};
</script>
